<div
	style="
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		flex-direction: row-reverse;
	"
>
	<mat-icon style="color: #9ca3af !important" mat-dialog-close>close </mat-icon>
</div>
<h1
	mat-dialog-title
	style="font-size: 20px; font-weight: 600; text-align: center"
>
	Retroalimentación
</h1>

<div class="comments-container mb2" #commentsContainer>
	<div
		*ngIf="!hasCommentsDb && !hasCommentsLocal; else comentariosList"
		style="display: flex; justify-content: center"
	>
		<span>--- Sin comentarios ---</span>
	</div>
	<ng-template #comentariosList>
		<div *ngFor="let comments of this.commentsDb; let i = index">
			<div class="comment-item">
				<div class="flex flex-wrap">
					<div class="comment-item-icon col-1">
						<div
							class="item-user-avatar"
							[style.background-color]="getAvatar(comments.user).color"
						>
							{{ getAvatar(comments.user).initials }}
						</div>
					</div>
					<div class="comment-item-body col-10">
						<div class="comment-header">
							<span class="comment-author">
								{{ comments.user.name }}
							</span>
							<span>
								{{ comments.date | date : 'mediumDate' }}
							</span>
						</div>
						<div class="comment-comment">
							{{ comments.comment }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngFor="let comments of commentsLocal; let i = index">
			<div class="comment-item">
				<div class="flex flex-wrap">
					<div class="comment-item-icon col-1">
						<div
							class="item-user-avatar"
							[style.background-color]="getAvatar(comments.user).color"
						>
							{{ getAvatar(comments.user).initials }}
						</div>
					</div>
					<div class="comment-item-body col-10">
						<div class="comment-header">
							<span class="comment-author">
								{{ comments.user.name }}
							</span>
							<span>
								{{ comments.date | date : 'mediumDate' }}
							</span>
						</div>
						<div class="comment-comment">
							{{ comments.description }}
						</div>
					</div>
					<div class="comment-actions col-1 center">
						<button
							mat-icon-button
							color="danger"
							*ngIf="
								actualUser === comments.user.name && comments.fromLocalStorage
							"
							(click)="deleteComment(this.data.id, i)"
						>
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>
<div class="clearfix" *ngIf="!isEditMode">
	<div>
		<form>
			<mat-form-field appearance="fill" class="col col-10 px2">
				<mat-label>Comentario</mat-label>
				<input
					autocomplete="off"
					matInput
					name="comment_text"
					[(ngModel)]="commentText"
					(input)="onCommentInput()"
				/>
			</mat-form-field>
		</form>
	</div>
	<div class="col col-2 px2">
		<button
			[disabled]="empty"
			mat-raised-button
			color="primary"
			(click)="addOrUpdateComment(data)"
		>
			Agregar
		</button>
	</div>
</div>

<div
	style="
		display: flex;
		justify-content: center !important;
		margin-top: 1rem;
		gap: 16px;
	"
>
	<button mat-raised-button type="button" mat-dialog-close>Cerrar</button>
</div>
